import React, { useEffect, useMemo, useState } from "react";
import {
  maxBtcAllowed,
  maximumStableCoinAtReceive,
  maxSatsAllowed,
  minBtcRequired,
  minOneSatRequired,
  minStableCoinRequired,
  sats,
  submit,
  XAUT,
  maxXautAtReceive,
  minXautAtReceive,
} from "./messages";
import { Box } from "@mui/material";
import Button from "./button/Button";
import {
  satsToBtcAmount,
  handleAmountChangeCommon,
  maximumAmountStableCoinReceive,
  minAmountRequiredForStableCoins,
  maxAmountAllowedSats,
  minAmountRequiredSatsAtReceive,
  minAmountRequiredForXautReceive,
  maxAmountRequiredForXautReceive,
  stableCoins,
} from "./constants";
import EnterAmountBox from "./EnterAmountBox";
import { useSelector } from "react-redux";

function EnterAmountCommon({
  amount,
  setAmount,
  customClass,
  isFromBrowser,
  onSubmit,
  convertedAmount,
  setConvertedAmount,
  note,
  setNote,
  setCheckExchange,
  checkExchange,
  taprootAsset,
  exchangeRate,
  setIsContentChanged,
  qrLoader,
  setQrLoader,
  isReset,
  setIsReset,
  selectedMethodName,
  isSelectedAmountOrNote,
  setIsSelectedAmountOrNote,
}) {
  const [currentAmount, setCurrentAmount] = useState(amount);
  const [currentConvertedAmount, setCurrentConvertedAmount] =
    useState(convertedAmount);
  const [currentNote, setCurrentNote] = useState(note);
  const [isLargeAmount, setIsLargeAmount] = useState(false);

  const showBtcAmount = useSelector((state) => state.common.showBtcAmount);

  useEffect(() => {
    setQrLoader(false);
    return () => {
      setIsContentChanged(false);
      setIsReset(false);
    };
  }, []);

  useEffect(() => {
    if (isReset) {
      setCurrentAmount(0);
      setCurrentConvertedAmount(0);
      setCurrentNote("");
      setIsLargeAmount(false);
    }
  }, [isReset]);

  useEffect(() => {
    setIsReset(false);
  }, [currentAmount, currentNote]);

  const receiveCalculations = useMemo(() => {
    const numAmount = Number(currentAmount);

    let btnLabel = submit,
      btnDisable = false;

    const handleLimits = (minAmount, maxAmount, minLabel, maxLabel) => {
      if (numAmount < minAmount) {
        btnLabel = minLabel;
        btnDisable = true;
      } else if (numAmount > maxAmount) {
        btnLabel = maxLabel;
        btnDisable = true;
      }
    };

    if (stableCoins.includes(taprootAsset?.uuid)) {
      handleLimits(
        minAmountRequiredForStableCoins,
        maximumAmountStableCoinReceive,
        minStableCoinRequired(taprootAsset?.uuid),
        maximumStableCoinAtReceive(taprootAsset?.uuid)
      );
    } else if (taprootAsset?.uuid === XAUT) {
      handleLimits(
        minAmountRequiredForXautReceive,
        maxAmountRequiredForXautReceive,
        minXautAtReceive,
        maxXautAtReceive
      );
    } else if (taprootAsset?.uuid === sats) {
      if (showBtcAmount) {
        const minAmountBtc = satsToBtcAmount(minAmountRequiredSatsAtReceive);
        const maxAmountBtc = satsToBtcAmount(maxAmountAllowedSats);
        handleLimits(
          minAmountBtc,
          maxAmountBtc,
          minBtcRequired(minAmountBtc),
          maxBtcAllowed(maxAmountBtc)
        );
      } else {
        handleLimits(
          minAmountRequiredSatsAtReceive,
          maxAmountAllowedSats,
          minOneSatRequired(),
          maxSatsAllowed()
        );
      }
    }
    return {
      btnLabel,
      btnDisable,
    };
  }, [currentAmount]);

  const handleAmountChange = (e) => {
    const mainAmount = e.target.value;
    const amount = showBtcAmount ? mainAmount?.slice(0, 10) : mainAmount;

    handleAmountChangeCommon(
      mainAmount,
      checkExchange,
      exchangeRate,
      taprootAsset?.uuid,
      setCurrentAmount,
      setCurrentConvertedAmount
    );

    taprootAsset?.uuid === sats &&
      setIsLargeAmount(satsToBtcAmount(amount) > 5);
  };

  const handleChangeCurrency = () => {
    setCheckExchange(!checkExchange);
  };

  const enterAmountBoxProps = {
    isFromBrowser,
    checkExchange,
    currentAmount,
    currentConvertedAmount,
    currentNote,
    setCurrentNote,
    currency: taprootAsset?.uuid,
    handleChangeCurrency: handleChangeCurrency,
    handleAmountChange: (e) => {
      setIsContentChanged(true);
      handleAmountChange(e);
    },
    setIsContentChanged,
    from: "payment",
    selectedMethodName,
    isSelectedAmountOrNote,
    setIsSelectedAmountOrNote,
  };

  return (
    <Box className={customClass}>
      <Box className="amount-container">
        <Box>
          <EnterAmountBox {...enterAmountBoxProps} />
        </Box>

        <Button
          sx={!isFromBrowser ? { margin: "14px 20px" } : {}}
          disabled={isLargeAmount || receiveCalculations?.btnDisable}
          fullWidth
          variant="contained"
          className="submit-btn"
          label={receiveCalculations?.btnLabel}
          onClick={() => {
            setAmount(currentAmount);
            setConvertedAmount(currentConvertedAmount);
            setNote(currentNote);
            onSubmit(currentAmount, currentNote);
          }}
          loading={qrLoader}
        />
      </Box>
    </Box>
  );
}

export default React.memo(EnterAmountCommon);
